export default {
    buildings: [
        {
            ref: "pav1_3",
            title: "P 01-03",
            pavilion: [
                "pav1",
                "pav3"
            ],
            thematics: [
                "umbrella",
                "homent",
                "smartoffice",
                "eclectic",
                "rug",
                "dol"
            ],
            center: {lat: 45.517404547972504, lng: 9.0829660782425}
        },
        {
            ref: "pav2_4",
            title: "P 02-04",
            pavilion: [
                "pav2",
                "pav4"
            ],
            thematics: [
                "dol",
                "uol"
            ],
            center: {lat: 45.51977094554, lng: 9.084641596885}
        },
        {
            ref: "pav5_7",
            title: "P 05-07",
            pavilion: [
                "pav5",
                "pav7"
            ],
            thematics: [
                "wallpaper",
                "umbrella",
                "homent",
                "eclectic",
                "rug"
            ],
            center: {lat: 45.518486051029996, lng: 9.08057912806}
        },
        {
            ref: "pav6_10",
            title: "P 06-10",
            pavilion: [
                "pav6",
                "pav10"
            ],
            thematics: [
                "dol",
                "uol"
            ],
            center: {lat: 45.52043912007, lng: 9.081303605317501}
        },
        {
            ref: "pav9_11",
            title: "P 09-11",
            pavilion: [
                "pav9",
                "pav11"
            ],
            thematics: [
                "homent",
                "smartoffice",
            ],
            center: {lat: 45.519864817035, lng: 9.075825940384998}
        },
        {
            ref: "pav13_15",
            title: "P 13-15",
            pavilion: [
                "pav13",
                "pav15"
            ],
            thematics: [
                "homent",
                "wallpaper",
                "eclectic",
                "rug"
            ],
            center: {lat: 45.5207451646875, lng: 9.073293433275}
        },
        {
            ref: "pav14_18",
            title: "P 14-18",
            pavilion: [
                "pav14",
                "pav18"
            ],
            thematics: [
                "wallpaper",
                "homent",
                "smartoffice",
                "eclectic",
                "rug"
            ],
            center: {lat: 45.5216703575, lng: 9.0777833391}
        },
        {
            ref: "pav22_24",
            title: "P 22-24",
            pavilion: [
                "pav22",
                "pav24"
            ],
            thematics: [
                "umbrella",
                "wallpaper",
                "smartoffice",
                "eclectic",
                "rug"
            ],
            center: {lat: 45.52294009775724, lng: 9.074819554722694}
        }
    ]  
};